define('modules/editor/models/elements/area',['require','exports','module','backbone','../../collections/elements','lib/util','../../behaviours/has_property_groups','../../behaviours/has_geometry','../../behaviours/has_elements'],function(require, exports, module) {
  "use strict";
  var Backbone = require("backbone"),
      ElementsCollection = require("../../collections/elements"),
      util = require("lib/util");

  // Serialization for this element is a mix from Base Element and Section
  var Serialization = {
    fromJSON: function(json, options) {
      var area = new module.exports(_.omit(json, "elements"), options),
          elementsModels = ElementsCollection.fromJSON(json.elements || [], options);

      area.elements.reset(elementsModels.toArray());
      return area;
    },
    toJSON: function() {
      return _.extend(
        module.exports.__super__.toJSON.call(this),
        { name: this.name },
        { elements: this.elements.toJSON() },
        { properties: _.invoke(this.propertyGroups, "toJSON") }
      );
    }
  };


  module.exports = Backbone.Model.extend({
    name: "element:area",
    defaultNameKey:"area",
    defaultPropertyGroups: [],
    defaults: {
      displayOrder: 0
    },
    geometryProperty: "geometry",
    propertyGroups: [
      { name: "geometry",
        defaults: { width: 150, height: 150 }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "background",
        defaults: {
          color: "#e0e0e0",
          direction: "to right",
          opacity: 10,
          type: "solid",
          imageUrl: ""
        }
      },
      {
        name: "border",
        defaults: {
          type: "solid",
          width: 1,
          color: "#000000",
          radius: 0,
          top: true,
          bottom: true,
          left: true,
          right: true
        }
      }
    ],
    constructor: function(attributes, options) {
      this.initPropertyGroupsWithDefaults();
      module.exports.__super__.constructor.call(this, attributes, _.omit(options, "silenceNotify"));
      //property groups are already initialized here
      if(attributes && attributes.x && attributes.y){
        //set position when dragging into section
        this.setPosition(_.pick(attributes, "x", "y"));
        delete attributes.x;
        delete attributes.y;
      }
      this.setPropertyGroups(_.result(attributes, 'properties'), _.pick(options, "silenceNotify"));
    },
    initialize: function() {
      module.exports.__super__.initialize.apply(this, arguments);
      this.elements = this.elements || new ElementsCollection();
    },
    _calculateElementsDimension: function() {
      var areaPos = this.getPosition();
      return this.elements.reduce(function(dimension, element) {
        var pos = element.getPosition(),
            size = element.getSize();
        // some elements has no minimum height, let's give the one that empty form has
        if (isNaN(size.height)) size.height = 32;
        dimension.top = Math.min(dimension.top, areaPos.y + pos.y);
        dimension.left = Math.min(dimension.left, areaPos.x + pos.x);
        dimension.bottom = Math.max(dimension.bottom, areaPos.y + pos.y + size.height);
        dimension.right = Math.max(dimension.right, areaPos.x + pos.x + size.width);
        return dimension;
      }, {
        top: 100000,
        bottom: 0,
        left: 100000,
        right: 0
      });
    },
    _adjustResize: function(geoData) {
      var elementsDimension = this._calculateElementsDimension(),
          data = {
            x: geoData.origLeft,
            y: geoData.origTop,
            width: geoData.origWidth,
            height: geoData.origHeight
          };
      var newLeft = geoData.newLeft || geoData.origLeft,
          newTop = geoData.newTop || geoData.origTop,
          newWidth = geoData.newWidth || geoData.origWidth,
          newHeight = geoData.newHeight || geoData.origHeight;
      if (((newLeft < elementsDimension.left + geoData.deltaX) && (newLeft + newWidth > elementsDimension.right + geoData.deltaX)) ||
         ((newLeft < elementsDimension.left) && (newLeft + newWidth > elementsDimension.right))) {
        data.x = geoData.newLeft || data.x;
        data.width = geoData.newWidth || data.width;
      }
      if (((newTop <= elementsDimension.top + geoData.deltaY) && (newTop + newHeight >= elementsDimension.bottom + geoData.deltaY)) ||
          ((newTop <= elementsDimension.top) && (newTop + newHeight >= elementsDimension.bottom)))  {
        data.y = geoData.newTop || data.y;
        data.height = geoData.newHeight || data.height;
      }
      return data;
    },
    getIdProp: function(){
      var idclass = this.getPropertyGroup("idclass");
      return idclass.get("id");
    },
    toJSON: Serialization.toJSON
  },
  {
    fromJSON: Serialization.fromJSON
  });

  util.mixin(module.exports, require("../../behaviours/has_property_groups"));
  util.mixin(module.exports, require("../../behaviours/has_geometry"));
  util.mixin(module.exports, require("../../behaviours/has_elements"));
});

